//import images from 'assets/images/images'

import {useRequest} from 'hooks/useRequest'
import useTranslate from 'hooks/useTranslate'
import LoaderTwo from 'pages/LoaderTwo'
import { useEffect, useState } from 'react'
import auth from 'utils/Auth'
import { dataLayerPush } from 'utils/Datalayer'

const StageTakeaway = () => {
	const [channelMap, setChannelMap] = useState([])
	const [request] = useRequest()
	const [loading, setLoading] = useState(true)
	const [channelAnnounce, setChannelAnnounce] = useState(null)
	const {t} = useTranslate()
	useEffect(() => {
		setLoading(true)
		setChannelMap(auth?.getUserChoises()?.channels)
		request('/Setting',{
			method:'GET'
		}).then(res => {
			setChannelAnnounce(res?.data?.result?.announcement)
		})
		setLoading(false)
	}, [])

	const channelFunc = (channelInfo) => {
		dataLayerPush({
            event:"takeaway_service",
            service_name: channelInfo.name
          })
		window.open(channelInfo.link, "_blank")
	}

	return (
		<div className='channelStage'>
			<LoaderTwo isDataLoading={loading} />
			{
				(channelAnnounce?.channelTitle || channelAnnounce?.channelDescription ) && <div className='channelStage-announce'>
				{
					channelAnnounce?.channelIconPath && <img className='channelStage-announce-img' src={channelAnnounce?.channelIconPath} alt='' />
				}
				<div>
					{
						channelAnnounce?.channelTitle && <div className='header-l'>{channelAnnounce?.channelTitle}</div>
					}
					{
						channelAnnounce?.channelDescription && <div className='body-m'>
						{channelAnnounce?.channelDescription}
					</div>
					}
				</div>
			</div>
			}
			<div className='channelStage-container'>
				<div className='channelStage-title'>
					<div className='channelStage-title-one'>{t('takeaway')}</div>
					<div className='channelStage-title-two'>
						{t('noTakeawayRestaurant')}
					</div>
				</div>

				<div className='channelStage-data'>
					{channelMap?.map((st, i) => (
						<div key={i} className='channelStage-data-item'>
							<div className='channelStage-data-item-left'>
								<img src={st.logoLink} alt='' />
								<div className='channelStage-data-item-left-title'>{st?.name}</div>
							</div>
							<a rel="noreferrer" target='_blank' onClick={() => channelFunc(st)} className='channelStage-data-item-right'>
								{t('goToChannelBtn')}
							</a>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

export default StageTakeaway
